<template>
  <div>
    <ul class="c-list">
      <li
        v-for="item in lessonInfo.articles"
        :key="item.id"
        @click="jumpToApp(item.lock, !!lessonInfo.readPermission, item)"
      >
        <trainListItem
          :item="item"
          :goodsType="goodsType"
          :chapter="false"
          v-if="goodsType == constants.goodsType.training"
        ></trainListItem>
        <courseListItem
          :item="item"
          :goodsType="goodsType"
          :chapter="false"
          v-if="goodsType == constants.goodsType.course"
        ></courseListItem>
      </li>
    </ul>
  </div>
</template>

<script>
import trainListItem from './train-list-item.vue'
import courseListItem from './course-list-item.vue'
import { saveUserInfo } from '@/utils/storage'
export default {
  components: {
    trainListItem,
    courseListItem,
  },
  props: {
    lessonInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    resourceId: {
      type: [Number, String],
      default: 0,
    },
    goodsType: {
      type: [Number, String],
      default: 0,
    },
    goodsId: {
      type: [Number, String],
      default: 0,
    },
    query: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      isClicked: false,
    }
  },
  methods: {
    async userLoginInfo() {
      if (this.isClicked) return
      this.isClicked = true
      let res = await this.api.login.userLoginInfo()
      if (res && res.code == 200) {
        saveUserInfo(res.data)
        this.$router.push({
          name: 'payment',
          query: {
            ...this.query,
            id: this.goodsId,
            isGoodsGroup: 0,
            memberVip: 0, //是否会员（0:不是 1：会员）quxiao
          },
        })
      }
      this.isClicked = false
    },
    jumpToGuide() {
      this.$router.push({
        name: 'download',
      })
    },
    jumpToApp(lock, readPermission, item) {
      if (item.type == 0) {
        if (this.origin != 'miniprogram') {
          this.$messageBox({
            title: '打开更新学堂APP去查看作业详情',
            show: true,
            btnType: 2,
            cancelBtnText: '暂不查看',
            confirmBtnText: '去查看',
            origin: this.origin,
            showOpenApp: true,
            confirmCallback: () => {
              if (this.origin == 'miniprogram') {
                this.jumpToGuide()
              } else {
                this.openApp()
              }
            },
          })
        }
        return
      }
      if (readPermission) {
        // 已购
        // 未到日期（提示）
        if(lock){ 
          return alert(item.tips)
        }
        // 已购
        this.$router.push({
          name: 'course-study',
          query: {
            goodsType: this.goodsType,
            goodsId: this.goodsId,
            resourceId: this.resourceId,
            id: item.id,
            adminId: '',
          },
        })
      } else {
        if (lock) {
          let self = this
          this.$messageBox({
            title: '购买课程解锁完整内容',
            show: true,
            btnType: 2,
            cancelBtnText: '暂不考虑',
            confirmBtnText: '立即购买',
            isMobileWx: false,
            confirmCallback: () => {
              if (
                self.goodsType == self.constants.goodsType.course ||
                self.goodsType == self.constants.goodsType.column
              ) {
                self.userLoginInfo()
              }
              if (self.goodsType == self.constants.goodsType.training) {
                self.$router.push({
                  path: '/timetable/schedule',
                  query: self.query,
                })
              }
            },
          })
        } else {
          // 试听
          this.$router.push({
            name: 'course-study',
            query: {
              goodsType: this.goodsType,
              goodsId: this.goodsId,
              resourceId: this.resourceId,
              id: item.id,
              adminId: '',
            },
          })
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.c-list {
  padding: 0 12px;
}
</style>
